module.exports = __webpack_public_path__ + "static/3-f6eced570a59925330adaeab1ad33184.jpg";